import { createSlice } from "@reduxjs/toolkit";

/**
 * The menu, as the order pad and the menu board both see it.
 *
 * One list, two screens: whichever loads first fills it, and
 * `isProductsDataFetched` stops the other fetching it again. Wiped on logout by
 * the reset in store.js, so one business's menu is never visible to the next.
 */
const initialState = {
  products: [],
  isProductsDataFetched: false,
};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload || [];
    },

    setProductDataFetched: (state, action) => {
      state.isProductsDataFetched = action.payload;
    },

    /** The item the server created, exactly as it came back. */
    addProduct: (state, action) => {
      if (action.payload) state.products.push(action.payload);
    },

    updateProduct: (state, action) => {
      const { _id, updated } = action.payload;
      const index = state.products.findIndex((product) => product._id === _id);
      if (index !== -1) {
        state.products[index] = { ...state.products[index], ...updated };
      }
    },

    /**
     * Off the board.
     *
     * The server does not drop the row — it marks it unavailable, because
     * orders already placed still point at it. Dropping it here is only this
     * screen catching up with a list that would no longer include it.
     */
    removeProduct: (state, action) => {
      state.products = state.products.filter((product) => product._id !== action.payload);
    },
  },
});

export const {
  setProducts,
  setProductDataFetched,
  addProduct,
  updateProduct,
  removeProduct,
} = productSlice.actions;

export default productSlice.reducer;
